import api from "@/apis/EmployeeStatusAPI";
import Crud from "./crud-base";
var crud = new Crud("EmployeeStatus", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "EmployeeStatusID",
      name: "EmployeeStatusName",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
